/**
 * Pixel Meta (Facebook) — mesure des campagnes publicitaires.
 *
 * ⚠️ UN SEUL endroit porte l'identifiant : la constante ci-dessous. Le pixel
 * est INACTIF tant qu'elle est vide, et rien d'autre dans l'application n'a
 * besoin de le savoir — tous les appels ci-dessous deviennent des non-opérations.
 *
 * Ce fichier ne vit que sur roofborder.com. Le widget servi aux couvreurs
 * (backend WIDGET_JS) ne charge JAMAIS ce pixel : il tourne sur LEURS sites,
 * suivre leurs visiteurs pour notre compte serait à la fois inutile et fautif.
 * Il se contente d'émettre l'événement DOM « roofborder:estimation », que
 * seule notre page d'accueil écoute.
 */

import { pistageAutorise } from "@/lib/consentement";

// Identifiant du pixel Meta (Gestionnaire d'événements → Sources de données).
// Vide = aucun script chargé, aucun cookie posé.
// « Roof Border Web », créé le 2026-08-04 dans le portefeuille business
// Roof Border (2004301523524011).
export const PIXEL_ID = "4592384707649806";

let charge = false;

/**
 * Charge le code de base Meta. Idempotent, sans effet si l'ID est vide.
 *
 * ⚠️ Loi 25 : rien ne part tant que le visiteur n'a pas explicitement accepté
 * (voir lib/consentement.js). Pas de réponse = refus. Ne jamais inverser ce
 * test « pour que ça marche » : c'est lui qui rend le site conforme.
 */
export function initPixel() {
  if (charge || !PIXEL_ID || !pistageAutorise()) return;
  charge = true;
  /* Code de base Meta, réécrit lisiblement plutôt que collé minifié. */
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  window.fbq("init", PIXEL_ID);
}

/** Vue de page. À rappeler à chaque changement de route (application SPA). */
export function pageVue() {
  if (!window.fbq) return;
  window.fbq("track", "PageView");
}

/**
 * Événement standard Meta (Lead, InitiateCheckout, Purchase…).
 * Les paramètres restent volontairement minces : aucune donnée personnelle
 * (ni courriel, ni adresse) ne part chez Meta depuis ici.
 *
 * `eventID` : à fournir quand le MÊME événement part aussi du serveur (API
 * Conversions). Meta rapproche les deux et n'en compte qu'un. Sans lui, une
 * vente serait comptée deux fois et ton coût par acquisition semblerait
 * deux fois meilleur qu'il ne l'est.
 */
export function evenement(nom, params, eventID) {
  if (!window.fbq) return;
  window.fbq("track", nom, params || {}, eventID ? { eventID } : undefined);
}
